var currTime = new Date().getTime();

var fileurl = 'https://cdn.shopify.com/s/files/1/0111/0537/0171/files/';
var colors = "Blue|Pink & Green Mix|Orange|Pink|White & Pink|Black|Royal Blue|Gold|Green|Dark Green|Hot Pink|Light Pink|Rainbow|Red|Silver|Light Purple|Purple|White|Yellow|Light Yellow";
var colorsArr = colors.split('|');
var currentActive = 0;

var productList = '[{"sku":"SS04-S-1","handle":"classic-round-grey-small-solid"},{"sku":"SS04-S-2","handle":"classic-round-grey-small-checkered"},{"sku":"SS04-S-3","handle":"classic-round-grey-small-halo"},{"sku":"SS04-M-1","handle":"classic-round-grey-medium-solid"},{"sku":"SS04-M-2","handle":"classic-round-grey-medium-checkered"},{"sku":"SS04-M-3","handle":"classic-round-grey-medium-halo"},{"sku":"SS04-M-4","handle":"classic-round-grey-medium-center-rose"},{"sku":"SS04-M-5","handle":"classic-round-grey-medium-gradient"},{"sku":"SS04-L-1","handle":"classic-round-grey-large-solid"},{"sku":"SS04-L-2-2","handle":"classic-round-grey-large-checkered-2-color"},{"sku":"SS04-L-2-3","handle":"classic-round-grey-large-checkered-3-color"},{"sku":"SS04-L-3","handle":"classic-round-grey-large-halo"},{"sku":"SS04-L-4","handle":"classic-round-grey-large-gradient"},{"sku":"SS04-L-5","handle":"classic-round-grey-large-heart"},{"sku":"SS04-L-6-L","handle":"classic-round-grey-large-letter"},{"sku":"SS04-L-7-N","handle":"classic-round-grey-large-number"},{"sku":"SS04-L-8","handle":"classic-round-grey-large-center-rose"},{"sku":"SS05-S-1","handle":"classic-heart-grey-small-solid"},{"sku":"SS05-S-2","handle":"classic-heart-grey-small-checkered"},{"sku":"SS05-S-3","handle":"classic-heart-grey-small-halo"},{"sku":"SS05-M-1","handle":"classic-heart-grey-medium-solid"},{"sku":"SS05-M-2","handle":"classic-heart-grey-medium-checkered"},{"sku":"SS05-M-3","handle":"classic-heart-grey-medium-halo"},{"sku":"SS05-M-4","handle":"classic-heart-grey-medium-center-rose"},{"sku":"SS05-L-1","handle":"classic-heart-grey-large-solid"},{"sku":"SS05-L-2-2","handle":"classic-heart-grey-large-checkered-2-color"},{"sku":"SS05-L-2-3","handle":"classic-heart-grey-large-checkered-3-color"},{"sku":"SS05-L-3","handle":"classic-heart-grey-large-halo"},{"sku":"SS05-L-4","handle":"classic-heart-grey-large-gradient"},{"sku":"SS05-L-5-L","handle":"classic-heart-grey-large-letter"},{"sku":"SS05-L-6-N","handle":"classic-heart-grey-large-number"},{"sku":"SS05-L-7","handle":"classic-heart-grey-large-center-rose"},{"sku":"SS06-S-1","handle":"huggy-round-small-solid"},{"sku":"SS06-S-2","handle":"huggy-round-small-checkered"},{"sku":"SS06-S-3","handle":"huggy-round-small-halo"},{"sku":"SS06-S-4","handle":"huggy-round-small-center-rose"},{"sku":"SS06-S-5","handle":"huggy-round-small-gradient"},{"sku":"SS06-M-1","handle":"huggy-round-medium-solid"},{"sku":"SS06-M-2","handle":"huggy-round-medium-checkered"},{"sku":"SS06-M-3","handle":"huggy-round-medium-halo"},{"sku":"SS06-M-4","handle":"huggy-round-medium-gradient"},{"sku":"SS06-M-5-L","handle":"huggy-round-medium-letter"},{"sku":"SS06-M-6-N","handle":"huggy-round-medium-number"},{"sku":"SS06-M-7","handle":"huggy-round-medium-center-rose"},{"sku":"SS06-L-1","handle":"huggy-round-large-solid"},{"sku":"SS06-L-2-2","handle":"huggy-round-large-checkered-2-color"},{"sku":"SS06-L-2-3","handle":"huggy-round-large-checkered-3-color"},{"sku":"SS06-L-3","handle":"huggy-round-large-halo"},{"sku":"SS06-L-4","handle":"huggy-round-large-gradient"},{"sku":"SS06-L-7","handle":"huggy-round-large-heart"},{"sku":"SS06-L-5-L","handle":"huggy-round-large-letter"},{"sku":"SS06-L-6-N","handle":"huggy-round-large-number"},{"sku":"SS06-L-8","handle":"huggy-round-large-center-rose"},{"sku":"SS07-1","handle":"huggy-heart-onesize-solid"},{"sku":"SS07-2-2","handle":"huggy-heart-onesize-checkered-2-color"},{"sku":"SS07-2-3","handle":"huggy-heart-onesize-checkered-3-color"},{"sku":"SS07-3","handle":"huggy-heart-onesize-halo"},{"sku":"SS07-4","handle":"huggy-heart-onesize-gradient"},{"sku":"SS07-5-L","handle":"huggy-heart-onesize-letter"},{"sku":"SS07-6-N","handle":"huggy-heart-onesize-number"},{"sku":"SS07-7","handle":"huggy-heart-onesize-center-rose"},{"sku":"SS08-1","handle":"huggy-square-onesize-solid"},{"sku":"SS08-2","handle":"huggy-square-onesize-checkered"},{"sku":"SS08-3","handle":"huggy-square-onesize-halo"},{"sku":"SS08-4-V","handle":"huggy-square-onesize-rows-vertical"},{"sku":"SS08-4-H","handle":"huggy-square-onesize-rows-horizontal"},{"sku":"SS08-5-V","handle":"huggy-square-onesize-gradient-vertical"},{"sku":"SS08-5-H","handle":"huggy-square-onesize-gradient-horizontal"},{"sku":"SS09-P-1","handle":"acrylic-square-clear-petite-solid"},{"sku":"SS09-S-1","handle":"acrylic-square-clear-small-solid"},{"sku":"SS09-S-4","handle":"acrylic-square-clear-small-checkered"},{"sku":"SS09-S-2","handle":"acrylic-square-clear-small-center-rose"},{"sku":"SS09-S-3-V","handle":"acrylic-square-clear-small-rows-vertical"},{"sku":"SS09-S-3-H","handle":"acrylic-square-clear-small-rows-horizontal"},{"sku":"SS09-S-5","handle":"acrylic-square-clear-small-x"},{"sku":"SS09-S-6","handle":"acrylic-square-clear-small-plus"},{"sku":"SS09-M-1","handle":"acrylic-square-clear-medium-solid"},{"sku":"SS09-M-2","handle":"acrylic-square-clear-medium-checkered"},{"sku":"SS09-M-3","handle":"acrylic-square-clear-medium-halo"},{"sku":"SS09-M-4-V","handle":"acrylic-square-clear-medium-rows-vertical"},{"sku":"SS09-M-4-H","handle":"acrylic-square-clear-medium-rows-horizontal"},{"sku":"SS09-M-5-V","handle":"acrylic-square-clear-medium-gradient-vertical"},{"sku":"SS09-M-5-H","handle":"acrylic-square-clear-medium-gradient-horizontal"},{"sku":"SS09-L-1","handle":"acrylic-square-clear-large-solid"},{"sku":"SS09-L-2","handle":"acrylic-square-clear-large-center-rose"},{"sku":"SS09-L-7","handle":"acrylic-square-clear-large-checkered"},{"sku":"SS09-L-8","handle":"acrylic-square-clear-large-halo"},{"sku":"SS09-L-3-V","handle":"acrylic-square-clear-large-rows-vertical"},{"sku":"SS09-L-3-H","handle":"acrylic-square-clear-large-rows-horizontal"},{"sku":"SS09-L-4-V","handle":"acrylic-square-clear-large-gradient-vertical"},{"sku":"SS09-L-4-H","handle":"acrylic-square-clear-large-gradient-horizontal"},{"sku":"SS09-L-5","handle":"acrylic-square-clear-large-x"},{"sku":"SS09-L-6","handle":"acrylic-square-clear-large-plus"},{"sku":"SS10-S-1","handle":"acrylic-heart-clear-small-solid"},{"sku":"SS10-S-2","handle":"acrylic-heart-clear-small-checkered"},{"sku":"SS10-S-3","handle":"acrylic-heart-clear-small-halo"},{"sku":"SS10-M-1","handle":"acrylic-heart-clear-medium-solid"},{"sku":"SS10-M-2","handle":"acrylic-heart-clear-medium-checkered"},{"sku":"SS10-M-3","handle":"acrylic-heart-clear-medium-halo"},{"sku":"SS10-M-4","handle":"acrylic-heart-clear-medium-center-rose"},{"sku":"SS10-L-1","handle":"acrylic-heart-clear-large-solid"},{"sku":"SS10-L-2","handle":"acrylic-heart-clear-large-checkered"},{"sku":"SS10-L-3","handle":"acrylic-heart-clear-large-halo"},{"sku":"SS10-L-4","handle":"acrylic-heart-clear-large-gradient"},{"sku":"SS10-L-5","handle":"acrylic-heart-clear-large-center-rose"}]';
 
var productListArr = JSON.parse(productList);
///'{"type":"Box Shape","data":[{"sku":"SS01","data":[{"title":"Classic Round Box","price":"0","sku":"SS04","image":"classic_round_box.png"},{"title":"Classic Heart Box","price":"0","sku":"SS05","image":"classic_heart_box.png"}]},{"sku":"SS02","data":[{"title":"Huggy Round Box","price":"0","sku":"SS06","image":"huggy_round_box.png"},{"title":"Huggy Heart Box","price":"170","sku":"SS07","image":"huggy_heart_box.png"},{"title":"Huggy Square Box","price":"0","sku":"SS08","image":"huggy_square_box.png"}]},{"sku":"SS03","data":[{"title":"Acrylic Square Box","price":"0","sku":"SS09","image":"acrylic_square_box.png"},{"title":"Acrylic Heart Box","price":"0","sku":"SS10","image":"acrylic_heart_box.png"}]}]}',
var steps = [
  '{"type":"Box Type","data":[{"title":"Shadow Box","price":"199.99","sku":"SS01","image":"Customize_Shadow_Box.png"},{"title":"Hat Box","price":"279.99","sku":"SS02","image":"Customize_Hat_Box.png"},{"title":"Arcylic Box","price":"129.99","sku":"SS03","image":"Customize_Acrylic.png"}]}',
  '{"type":"Box Shape","data":[{"sku":"SS01","data":[{"title":"Round","price":"0","sku":"SS04","image":"classic_round_box.png"},{"title":"Heart","price":"0","sku":"SS05","image":"classic_heart_box.png"}]},{"sku":"SS02","data":[{"title":"Round","price":"0","sku":"SS06","image":"huggy_round_box.png"},{"title":"Heart","price":"170","sku":"SS07","image":"huggy_heart_box.png"},{"title":"Square","price":"0","sku":"SS08","image":"huggy_square_box.png"}]},{"sku":"SS03","data":[{"title":"Square","price":"0","sku":"SS09","image":"acrylic_square_box.png"}]}]}',
  '{"type":"Box Color & Material","data":[{"sku":"SS04","data":[{"title":"Grey","sku":"SS04-G","price":"0","image":"classic_round_box.png"}]},{"sku":"SS05","data":[{"title":"Grey","price":"0","sku":"SS05-G","image":"classic_heart_box.png"}]},{"sku":"SS06","data":[{"title":"Black","price":"0","sku":"SS06-B","image":"hrb_black.png"},{"title":"White","price":"0","sku":"SS06-W","image":"hrb_white.png"}]},{"sku":"SS07","data":[{"title":"Black","price":"0","sku":"SS07-B","image":"hhb_black.png"},{"title":"White","price":"0","sku":"SS07-W","image":"hhb_white.png"}]},{"sku":"SS08","data":[{"title":"Black","price":"0","sku":"SS08-B","image":"hsb_black.png"},{"title":"White","price":"0","sku":"SS08-W","image":"hsb_white.png"}]},{"sku":"SS09","data":[{"title":"Clear","price":"0","sku":"SS09-C","image":"acrylic_square_box.png"}]}]}',
  '{"type":"Box Size","data":[{"sku":"SS04-G","data":[{"title":"Small","sku":"SS04-S","price":"0","dimensions":"8&quot; x 8&quot; x 4.5&quot;","roses":"11 ~ 13","image":"crb_small_220ecbaa-cb19-430f-a144-94185759fc2e.png"},{"title":"Medium","sku":"SS04-M","price":"100","dimensions":"10&quot; x 10&quot; x 5&quot;","roses":"20 ~ 22","image":"crb_medium_339e57a1-2a77-4ee0-953c-7e674314ec86.png"},{"title":"Large","sku":"SS04-L","price":"250","dimensions":"12&quot; x 12&quot; x 6&quot;","roses":"34 ~ 36","image":"crb_large_fac6bba6-2873-465e-ae7f-4e3dfb994522.png"}]},{"sku":"SS05-G","data":[{"title":"Small","sku":"SS05-S","price":"0","dimensions":"8&quot; x 7.5&quot; x 4.5&quot;","roses":"11 ~ 13","image":"chb_small_5fa59bf6-37c6-4539-9703-a7650a51128c.png"},{"title":"Medium","sku":"SS05-M","price":"100","dimensions":"10&quot; x 9.5&quot; x 5&quot;","roses":"20 ~ 22","image":"chb_medium_9e34ca23-6162-4ab7-99b0-425fba5a7c0b.png"},{"title":"Large","sku":"SS05-L","price":"250","dimensions":"14&quot; x 13&quot; x 5.5&quot;","roses":"34 ~ 36","image":"chb_large_10344431-2bd7-4a69-941d-4ecbe698144f.png"}]},{"sku":"SS06-B","data":[{"title":"Medium","sku":"SS06-B-S","price":"0","dimensions":"8&quot; x 8&quot; x 8&quot;","roses":"18 ~ 20","image":"hrb_small_black.png"},{"title":"Large","sku":"SS06-B-M","price":"120","dimensions":"10.5&quot; x 10.5&quot; x 8&quot;","roses":"31 ~ 33","image":"hrb_medium_black.png"},{"title":"Mega","sku":"SS06-B-L","price":"420","dimensions":"15&quot; x 15&quot; x 10&quot;","roses":"60 ~ 65","image":"hrb_large_black.png"}]},{"sku":"SS06-W","data":[{"title":"Medium","sku":"SS06-W-S","price":"0","dimensions":"8&quot; x 8&quot; x 8&quot;","roses":"18 ~ 20","image":"hrb_small_black.png"},{"title":"Large","sku":"SS06-W-M","price":"120","dimensions":"10.5&quot; x 10.5&quot; x 8&quot;","roses":"31 ~ 33","image":"hrb_medium_black.png"},{"title":"Mega","sku":"SS06-W-L","price":"420","dimensions":"15&quot; x 15&quot; x 10&quot;","roses":"60 ~ 65","image":"hrb_large_black.png"}]},{"sku":"SS07-B","data":[{"title":"One Size","price":"0","sku":"SS07-B-O","dimensions":"12&quot; x 12&quot; x 8&quot;","roses":"37 ~ 40","image":"hhb_os_black.png"}]},{"sku":"SS07-W","data":[{"title":"One Size","price":"0","sku":"SS07-W-O","dimensions":"12&quot; x 12&quot; x 8&quot;","roses":"37 ~ 40","image":"hhb_os_white.png"}]},{"sku":"SS08-B","data":[{"title":"One Size","price":"0","sku":"SS08-B-O","dimensions":"8&quot; x 8&quot; x 6&quot;","roses":"16","image":"hsb_os_white.png"}]},{"sku":"SS08-W","data":[{"title":"One Size","price":"0","sku":"SS08-W-O","dimensions":"8&quot; x 8&quot; x 6&quot;","roses":"16","image":"hsb_os_black.png"}]},{"sku":"SS09-C","data":[{"title":"Petite","price":"0","sku":"SS09-P","dimensions":"4&quot; x 4&quot;x 6&quot;","roses":"1","image":"asb_petite.png"},{"title":"Small","price":"140","sku":"SS09-S","dimensions":"6&quot; x 6&quot; x 6&quot;","roses":"9","image":"asb_small_2a989cc5-3542-46ac-bc52-1039411aae88.png"},{"title":"Medium","price":"240","sku":"SS09-M","dimensions":"8&quot; x 8&quot; x 6&quot;","roses":"16","image":"asb_medium_65a986e2-105c-450e-a9b2-af665fae6f13.png"},{"title":"Large","price":"370","sku":"SS09-L","dimensions":"10&quot; x 10&quot; x 6&quot;","roses":"25","image":"asb_large_6ed1287f-cf0f-4dfc-80fb-eb01c24f0d2f.png"}]},{"sku":"SS10-C","data":[{"title":"Small","price":"190","sku":"SS10-S","image":"acrylic_heart_box.png"},{"title":"Medium","price":"320","sku":"SS10-M","image":"acrylic_heart_box.png"},{"title":"Large","price":"470","sku":"SS10-L","image":"acrylic_heart_box.png"}]}]}',
  '{"type":"Arrangement","data":[{"sku":"SS04-S","data":[{"title":"Solid","price":"0","sku":"SS04-S-1","image":"crb_small_solid.png","color_design":"1-B"},{"title":"Checkered","price":"10","sku":" SS04-S-2","image":"crb_small_halo.png","color_design":"2-B|2-D"},{"title":"Halo","price":"10","sku":"SS04-S-3","image":"crb_small_checkered.png","color_design":"3-B|3-D"}]},{"sku":"SS04-M","data":[{"title":"Solid","price":"0","sku":"SS04-M-1","image":"crb_medium_solid.png","color_design":"4-B"},{"title":"Checkered","price":"20","sku":" SS04-M-2","image":"crb_medium_checkered.png","color_design":"5-B|5-D"},{"title":"Halo","price":"20","sku":"SS04-M-3","image":"grb_medium_halo.png","color_design":"6-B|6-D"},{"title":"Switch Center Rose Only","price":"20","sku":"SS04-M-4","image":"grb_medium_single_rose.png","color_design":"7-B|7-D"},{"title":"Gradient","price":"30","sku":"SS04-M-5","image":"grb_medium_gradiant.png","color_design":"8-B|8-D-1|8-D-2"}]},{"sku":"SS04-L","data":[{"title":"Solid","price":"0","sku":"SS04-L-1","image":"crb_large_solid.png","color_design":"9-B"},{"title":"Checkered","price":"40","sku":" SS04-L-2","image":"crb_large_checkered.png","suboption":[{"title":"2 Color Mix","price":"40","sku":"SS04-L-2-2","color_design":"10-B|10-D"},{"title":"3 Color Mix","price":"40","sku":"SS04-L-2-3","color_design":"11-B|11-D-1|11-D-2"}]},{"title":"Halo","price":"40","sku":"SS04-L-3","image":"crb_large_halo.png","color_design":"12-B|12-D"},{"title":"Gradient","price":"50","sku":"SS04-L-4","image":"crb_large_gradiant.png","color_design":"13-B|13-D-1|13-D-2|13-D-3"},{"title":"Heart","price":"40","sku":"SS04-L-5","image":"crb_large_heart.png","color_design":"14-B|14-D"},{"title":"Letter","price":"40","sku":" SS04-L-6","image":"crb_large_letter.png","suboption":[{"title":"Letter","max":"1","price":"40","sku":"SS04-L-6-L","color_design":"15-B|15-D"}]},{"title":"Number","price":"40","sku":" SS04-L-7","image":"crb_large_number.png","suboption":[{"title":"Number","price":"40","max":"1","sku":"SS04-L-7-N","color_design":"16-B|16-D"}]},{"title":"Switch Center Rose Only","price":"30","sku":"SS04-L-8","image":"crb_large_center_rose.png","color_design":"17-B|17-D"}]},{"sku":"SS05-S","data":[{"title":"Solid","price":"0","sku":"SS05-S-1","image":"chb_medium_solid.png","color_design":"42-B"},{"title":"Checkered","price":"10","sku":" SS05-S-2","image":"chb_small_checkered.png","color_design":"43-B|43-D"},{"title":"Halo","price":"10","sku":"SS05-S-3","image":"chb_small_halo.png","color_design":"44-B|44-D"}]},{"sku":"SS05-M","data":[{"title":"Solid","price":"0","sku":"SS05-M-1","image":"chb_medium_solid.png","color_design":"45-B"},{"title":"Checkered","price":"20","sku":" SS05-M-2","image":"chb_medium_checkered.png","color_design":"46-B|46-D"},{"title":"Halo","price":"20","sku":"SS05-M-3","image":"chb_medium_halo.png","color_design":"47-B|47-D"},{"title":"Switch Center Rose Only","price":"20","sku":"SS05-M-4","image":"chb_medium_center_rose.png","color_design":"48-B|48-D"}]},{"sku":"SS05-L","data":[{"title":"Solid","price":"0","sku":"SS05-L-1","image":"chb_large_solid.png","color_design":"49-B"},{"title":"Checkered","price":"40","sku":" SS05-L-2","image":"chb_large_checkered.png","suboption":[{"title":"2 Color Mix","price":"40","max":"2","sku":"SS05-L-2-2","color_design":"50-B|50-D"},{"title":"3 Color Mix","price":"50","max":"3","sku":"SS05-L-2-3","color_design":"57-B|57-D-1|57-D-2"}]},{"title":"Halo","price":"40","sku":"SS05-L-3","image":"chb_large_halo.png","color_design":"51-B|51-D"},{"title":"Gradient","price":"50","sku":"SS05-L-4","image":"chb_large_gradiant.png","color_design":"52-B|52-D-1|52-D-2|52-D-3"},{"title":"Letter","price":"40","sku":" SS05-L-5","image":"chb_large_letter.png","suboption":[{"title":"Letter","price":"40","max":"1","sku":"SS05-L-5-L","color_design":"53-B|53-D"}]},{"title":"Number","price":"40","sku":" SS05-L-6","image":"chb_large_number.png","suboption":[{"title":"Number","price":"40","max":"1","sku":"SS05-L-6-N","color_design":"54-B|54-D"}]},{"title":"Switch Center Rose Only","price":"40","sku":"SS05-L-7","image":"chb_large_center_rose.png","color_design":"55-B|55-D"}]},{"sku":"SS06-B-S|SS06-W-S","data":[{"title":"Solid","price":"0","sku":"SS06-S-1","image":"hrb_small_solid.png","color_design":"4-B"},{"title":"Checkered","price":"10","sku":" SS06-S-2","image":"hrb_small_checkered.png","color_design":"5-B|5-D"},{"title":"Halo","price":"10","sku":"SS06-S-3","image":"hrb_small_halo.png","color_design":"6-B|6-D"},{"title":"Switch Center Rose Only","price":"10","sku":"SS06-S-4","image":"hrb_small_center_only.png","color_design":"7-B|7-D"},{"title":"Gradient","price":"20","sku":"SS06-S-5","image":"hrb_small_gradiant.png","color_design":"8-B|8-D-1|8-D-2"}]},{"sku":"SS06-B-M|SS06-W-M","data":[{"title":"Solid","price":"0","sku":"SS06-M-1","image":"hrb_medium_solid.png","color_design":"9-B"},{"title":"Checkered","price":"20","sku":" SS06-M-2","image":"hrb_medium_checkered.png","color_design":"10-B|10-D"},{"title":"Halo","price":"20","sku":"SS06-M-3","image":"hrb_medium_halo.png","color_design":"12-B|12-D"},{"title":"Gradient","price":"60","sku":"SS06-M-4","image":"hrb_medium_gradiant.png","color_design":"13-B|13-D-1|13-D-2|13-D-3"},{"title":"Letter","price":"50","sku":" SS06-M-5","image":"hrb_medium_letter.png","suboption":[{"title":"Letter","max":"1","price":"50","sku":"SS06-M-5-L","color_design":"15-B|15-D"}]},{"title":"Number","price":"50","sku":" SS06-M-6","image":"hrb_medium_number.png","suboption":[{"title":"Number","max":"1","price":"50","sku":"SS06-M-6-N","color_design":"16-B|16-D"}]},{"title":"Switch Center Rose Only","price":"20","sku":"SS06-M-7","image":"hrb_medium_center_rose.png","color_design":"17-B|17-D"}]},{"sku":"SS06-B-L|SS06-W-L","data":[{"title":"Solid","price":"0","sku":"SS06-L-1","image":"hrb_large_solid.png","color_design":"9-B"},{"title":"Checkered","price":"30|70","sku":" SS06-L-2","image":"hrb_large_checkered.png","suboption":[{"title":"2 Color Mix","price":"30","max":"2","sku":"SS06-L-2-2","color_design":"10-B|10-D"},{"title":"3 Color Mix","price":"70","max":"3","sku":"SS06-L-2-3","color_design":"11-B|11-D-1|11-D-2"}]},{"title":"Halo","price":"30","sku":"SS06-L-3","image":"hrb_large_halo.png","color_design":"12-B|12-D"},{"title":"Gradient","price":"60","sku":"SS06-L-4","image":"hrb_large_gradient.png","color_design":"13-B|13-D-1|13-D-2|13-D-3"},{"title":"Heart","price":"60","sku":"SS06-L-7","image":"hrb_large_heart.png","color_design":"14-B|14-D"},{"title":"Letter","price":"60","sku":" SS06-L-5","image":"hrb_large_letter.png","suboption":[{"title":"Letter","max":"2","price":"60","sku":"SS06-L-5-L","color_design":"15-B|15-D"}]},{"title":"Number","price":"60","sku":" SS06-L-6","image":"hrb_large_number.png","suboption":[{"title":"Number","max":"2","price":"60","sku":"SS06-L-6-N","color_design":"16-B|16-D"}]},{"title":"Switch Center Rose Only","price":"30","sku":"SS06-L-8","image":"hrb_large_center_rose.png","color_design":"17-B|17-D"}]},{"sku":"SS07-B-O|SS07-W-O","data":[{"title":"Solid","price":"0","sku":"SS07-1","image":"hhb_ones_solid.png","color_design":"49-B"},{"title":"Checkered","price":"20","sku":" SS07-2","image":"hhb_ones_checkered.png","suboption":[{"title":"2 Color Mix","price":"20","max":"2","sku":"SS07-2-2","color_design":"50-B|50-D"},{"title":"3 Color Mix","price":"50","max":"3","sku":"SS07-2-3","color_design":"57-B|57-D-1|57-D-2"}]},{"title":"Halo","price":"50","sku":"SS07-3","image":"hhb_ones_halo.png","color_design":"51-B|51-D"},{"title":"Gradient","price":"60","sku":"SS07-4","image":"hhb_ones_gradient.png","color_design":"52-B|52-D-1|52-D-2|52-D-3"},{"title":"Letter","price":"50","sku":" SS07-5","image":"hhb_ones_letter.png","suboption":[{"title":"Letter","price":"60","max":"1","sku":"SS07-5-L","color_design":"53-B|53-D"}]},{"title":"Number","price":"50","sku":" SS07-6","image":"hhb_ones_number.png","suboption":[{"title":"Number","price":"60","max":"1","sku":"SS07-6-N","color_design":"54-B|54-D"}]},{"title":"Switch Center Rose Only","price":"30","sku":"SS07-7","image":"hhb_ones_center_rose.png","color_design":"55-B|55-D"}]},{"sku":"SS08-B-O|SS08-W-O","data":[{"title":"Solid","price":"0","sku":"SS08-1","image":"hsb_ones_solid.png","color_design":"25-B"},{"title":"Checkered","price":"20","sku":" SS08-2","image":"hsb_ones_checkered.png","color_design":"26-B|26-D"},{"title":"Halo","price":"20","sku":"SS08-3","image":"hsb_ones_halo.png","color_design":"27-B|27-D"},{"title":"Rows","price":"20","sku":" SS08-4","suboption":[{"title":"Vertical","price":"20","sku":"SS08-4-V","image":"hsb_ones_row_vertical.png","color_design":"28-B|28-D"},{"title":"Horizontal","sku":"SS08-4-H","price":"20","image":"hsb_ones_row_horizontal.png","color_design":"29-B|29-D"}]},{"title":"Gradient","price":"40","sku":" SS08-5","suboption":[{"title":"Vertical","sku":"SS08-5-V","price":"40","image":"hsb_ones_gradiant_vertical.png","color_design":"30-B|30-D-1|30-D-2|30-D-3"},{"title":"Horizontal","sku":"SS08-5-H","price":"40","image":"hsb_ones_gradiant_horizontal.png","color_design":"31-B|31-D-1|31-D-2|31-D-3"}]}]},{"sku":"SS09-P","data":[{"title":"Solid","price":"0","sku":"SS09-P-1","image":"asb_petite_solid.png","color_design":"18-B"}]},{"sku":"SS09-S","data":[{"title":"Solid","price":"0","sku":"SS09-S-1","image":"asb_small_solid.png","color_design":"19-B"},{"title":"Checkered","price":"20","sku":" SS09-S-4","image":"asb_small_checkered.png","color_design":"23-B|23-D"},{"title":"Switch Center Rose Only ","price":"10","sku":"SS09-S-2","image":"asb_small_center_rose.png","color_design":"20-B|20-D"},{"title":"Rows","price":"30","sku":"SS09-S-3","suboption":[{"title":"Horizontal","price":"30","sku":"SS09-S-3-H","image":"asb_small_rows_vertical.png","color_design":"21-B|21-D-1|21-D-2"},{"title":"Vertical","price":"20","sku":"SS09-S-3-V","image":"asb_small_rows_horizontal.png","color_design":"22-B|22-D-1|22-D-2"}]},{"title":"X Design","price":"20","sku":"SS09-S-5","image":"asb_small_x_design.png","color_design":"23-B|23-D"},{"title":"+ Design","price":"20","sku":"SS09-S-6","image":"asb_small___design.png","color_design":"24-B|24-D"}]},{"sku":"SS09-M","data":[{"title":"Solid","price":"0","sku":"SS09-M-1","image":"asb_medium_solid.png","color_design":"25-B"},{"title":"Checkered","price":"30","sku":" SS09-M-2","image":"asb_medium_checkered.png","color_design":"26-B|26-D"},{"title":"Halo","price":"30","sku":"SS09-M-3","image":"asb_medium_halo.png","color_design":"27-B|27-D"},{"title":"Rows","price":"30","sku":" SS09-M-4","suboption":[{"title":"Vertical","sku":" SS09-M-4-V","price":"30","image":"asb_medium_rows_vertical.png","color_design":"28-B|28-D"},{"title":"Horizontal","sku":"SS09-M-4-H","price":"30","image":"asb_medium_rows_horizontal.png","color_design":"29-B|29-D"}]},{"title":"Gradient","price":"40","sku":" SS09-M-5","suboption":[{"title":"Vertical","sku":"SS09-M-5-V","price":"40","image":"asb_medium_gradiant_vertical.png","color_design":"30-B|30-D-1|30-D-2|30-D-3"},{"title":"Horizontal","sku":"SS09-M-5-H","price":"40","image":"asb_medium_gradiant_horizontal.png","color_design":"31-B|31-D-1|31-D-2|31-D-3"}]}]},{"sku":"SS09-L","data":[{"title":"Solid","price":"0","sku":"SS09-L-1","image":"asb_large_solid.png","color_design":"32-B"},{"title":"Switch Center Rose Only","price":"10","sku":"SS09-L-2","image":"asb_large_center_rose.png","color_design":"33-B|33-D"},{"title":"Checkered","price":"30","sku":" SS09-L-7","image":"asb_large_checkered.png","color_design":"34-B|34-D"},{"title":"Halo","price":"30","sku":"SS09-L-8","image":"asb_large_halo.png","color_design":"35-B|35-D"},{"title":"Rows","price":"30","sku":" SS09-L-3","suboption":[{"title":"Vertical","sku":"SS09-L-3-V","price":"30","image":"asb_large_rows_vertical.png","color_design":"36-B|36-D"},{"title":"Horizontal","sku":"SS09-L-3-H","price":"30","image":"asb_large_rows_horizontal.png","color_design":"37-B|37-D"}]},{"title":"Gradient","price":"40","sku":" SS09-L-4","suboption":[{"title":"Vertical","sku":"SS09-L-4-V","price":"40","max":"3","is_image":true,"image":"asb_large_gradiant_vertical.png","color_design":"38-D"},{"title":"Horizontal","sku":"SS09-L-4-H","price":"40","image":"asb_large_gradiant_horizontal.png","color_design":"39-D"}]},{"title":"X Design","sku":"SS09-L-5","price":"30","image":"asb_large_x_design.png","color_design":"40-B|40-D"},{"title":"+ Design","sku":"SS09-L-6","price":"30","image":"asb_large___design.png","color_design":"41-B|41-D"}]},{"sku":"SS10-S","data":[{"title":"Solid","price":"0","sku":"SS10-S-1","image":"chb_small_solid.png","color_design":"42-B"},{"title":"Checkered","price":"10","sku":"SS10-S-2","image":"chb_small_checkered.png","color_design":"43-B|43-D"},{"title":"Halo","price":"10","sku":" SS10-S-3","image":"chb_small_halo.png","color_design":"44-B|44-D"}]},{"sku":"SS10-M","data":[{"title":"Solid","price":"0","sku":"SS10-M-1","image":"chb_medium_solid.png","color_design":"45-B"},{"title":"Checkered","price":"20","sku":"SS10-M-2","image":"chb_medium_checkered.png","color_design":"46-B|46-D"},{"title":"Halo","price":"20","sku":" SS10-M-3","image":"chb_medium_halo.png","color_design":"47-B|47-D"},{"title":"Switch Center Rose Only ","price":"20","sku":" SS10-M-4","image":"chb_medium_center_rose.png","color_design":"48-B|48-D"}]},{"sku":"SS10-L","data":[{"title":"Solid","price":"0","sku":"SS10-L-1","image":"chb_large_solid.png","color_design":"49-B"},{"title":"Checkered","price":"40","sku":"SS10-L-2","image":"chb_large_checkered.png","color_design":"50-B|50-D"},{"title":"Halo","price":"40","sku":" SS10-L-3","image":"chb_large_halo.png","color_design":"51-B|51-D"},{"title":"Gradient","price":"50","sku":" SS10-L-4","image":"chb_large_gradiant.png","color_design":"52-B|52-D-1|52-D-2|52-D-3"},{"title":"Switch Center Rose Only ","price":"40","sku":" SS10-L-5","image":"chb_large_center_rose.png","color_design":"55-B|55-D"}]}]}'
];

var lidMessage = "No Lid Message,Be My Valentine,Happy Mother's Day,I Love You,It's A Boy,It's A Girl,Save The Date,We're Engaged,We're Having A Baby,Will You Be My Bridesmaid?,Will You Be My Maid Of Honor?,Will You Marry Me?";
var lidMessageArr = lidMessage.split(',');
//console.log(steps);
// console.log();
var selection = [];

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
function eraseCookie(name) {
  document.cookie = name + "=; Max-Age=-99999999;";
}

$(steps).each(function(key, value){
  var d = JSON.parse(value), block = '', block_two = '', s, i = 0;
  console.log(d);
  $(d.data).each(function(k,v){
    if(i == 0){
      if(key != 0){
        selection[key] = v.data[0];
      }else{
        selection[key] = v;
      }
    }
    i += 1;
  });  
  var title = selection[key].title,
      sku = selection[key].sku,
      price = selection[key].price,
      type = d.type,
      color = selection[key].color_design,
  	  image = selection[key].image;
  
      if(selection[key].dimensions != undefined){ var dimensions = selection[key].dimensions; }
      if(selection[key].roses != undefined){ var  roses = selection[key].roses+' Roses'; }
  
  var active = '';
  var hide = '';
  if(key == 0){
    var active = 'active';
  }else{
    var hide = 'hide';
  }
  
  block += '<li class="list-option '+hide+'">'+
    '<button class="btn main-option '+active+'" data-index="'+key+'" data-title="'+title+'" data-type="'+d.type+'" data-dimension="'+dimensions+'" data-roses="'+roses+'" data-price="'+price+'" data-sku="'+sku+'">'+
    '<span class="type">'+d.type+'</span>'+
    '<h3>'+title+'</h3>';
  if(dimensions != undefined){
    block += '<span>'+ dimensions+" - "+roses +'</span>';
  }
  block +=  '</li>';
  $('div[data-type="box-arrangement-options"] .options').append(block);
  
  var block_two = '';
  block_two += '<li class="list-option-two">'+
    '<button class="btn main-option" data-index="'+key+'" data-title="'+title+'" data-type="'+d.type+'" data-dimension="'+dimensions+'" data-roses="'+roses+'" data-price="'+price+'" data-sku="'+sku+'">'+
    '<span class="type">'+d.type+'</span>'+
    '<h3>'+title+'</h3>';
  if(dimensions != undefined){
    block_two += '<span>'+ dimensions+" - "+roses +'</span>';
  }
  block_two +=  '</li>';
  $('div[data-type="box-arrangement-options-second"] .options-two').append(block_two);
  
  var f = key+1;
  if(f == steps.length){
    var folder = selection[4].color_design;
    //generateColorOptions(folder, false, '');
    showPrice(selection);
    generateMobileDetail(selection);
    var wWidth = $(window).width();
    if(wWidth <= 620){
      $('.mobile-area-wrapper').show();
      $('.mobile-area-wrapper').addClass('hasD');
    }
  }
});

/*
function generateColorOptions(folder, type){
  var colors = "Blue|Pink & Green Mix|Orange|Pink|White & Pink|Black|Royal Blue|Gold|Green|Dark Green|Hot Pink|Light Pink|Rainbow|Red|Silver|Light Purple|Purple|White|Yellow|Light Yellow";
  var colorsArr = colors.split('|');
  var fileurl = 'https://cdn.shopify.com/s/files/1/0111/0537/0171/files/';

  $('.color-option-block').html('');
  //console.log(folder);
  if(folder != undefined && folder.indexOf('|') != -1){
    var t = folder.split('|');
    
    var size = t.length;    
    for(var i=0; i<size; i++){
      var colorHTML = '';
      $(colorsArr).each(function(key,value){
        var index = key + 1;
        var ac = ''
        if(key == 0){var ac = ' active';}
        colorHTML += '<li><a data-image="'+fileurl+t[i]+'-'+index+'_450x.png" data-index="'+key+'" class="color-option'+ac+'" data-title="'+value+'"><img src="'+fileurl+'swatch-'+index+'_65x.png"></a></li>';
        //colorHTML += '<li><a data-index="'+key+'" class="color-option" data-title="'+value+'"><img src="'+fileurl+'swatch-'+index+'_65x.png"></a></li>';
      });
      var title = '';
      if(i == 0){title = 'Background color';}
      else if(i == 1){title = 'Foreground color';}
      else if(i == 2){title = 'Design Color 1';}
      else if(i == 3){title = 'Design Color 2';}
      $('.color-option-block').append('<h4 class="head-title">'+title+'</h4><ul class="color-options" data-index="'+i+'" >'+colorHTML+'</ul>');
    }
  }else{    
    var colorHTML = '';
    $(colorsArr).each(function(key,value){
      var index = key + 1;
      var ac = ''
      if(key == 0){var ac = ' active';}
      colorHTML += '<li><a data-image="'+fileurl+folder+'-'+index+'_450x.png" data-index="'+key+'" class="color-option'+ac+'" data-title="'+value+'"><img src="'+fileurl+'swatch-'+index+'_65x.png"></a></li>';
    });
    $('.color-option-block').append('<ul class="color-options">'+colorHTML+'</ul>');
  }
}
*/

$(document).ready(function(){
  $(document).on('click', '.main-option', function(){
    var c = $(document).find('div[data-type="box-arrangement-options"],div[data-type="box-arrangement-options-second"]').find('.active').data('index');
    
    //console.log($(document).find('.main-option').find('.active'));
    //hideLidMessage();
    $(document).find('.main-option').removeClass('active');
    $(this).addClass('active');
    
    var id = $(this).data('index');
    
    $(document).find('.options li').each(function(k,v){
      if(k > id){
        $(v).addClass('hide');
      }
    });
    
    if(id == 5){
      $('.steps').find('.add-to-cart').removeClass('hide');
      $('.steps').find('.next-btn').addClass('hide');
    }else{
      $('.steps').find('.add-to-cart').addClass('hide');
      $('.steps').find('.next-btn').removeClass('hide');
    }
    
    showPrice(selection);
    
    $('#steps-label').text("Choose "+$(this).data('type'));
    
    currentActive = id;
    
    //console.log(id+"  ==  "+c);
    
    if(id == 4 && c == 5){
      $('.arrangement-option ul').each(function(ka, va){
        if($(va).hasClass('hide')){        
        }else{
          $(va).find('.active').trigger('click');
        }
      });
    }else{
      if(id < 5){
        generateSteps(steps[id], id, selection);
      }else if(id > 5){
        if(id == 6){
          //showLidMessage();
        }
      }
    }
    
    /*if(id < 5){
      
    }*/
    //console.log(currentActive);
    if(currentActive != 0){
      $('.steps .back-btn').attr('disabled', false);
    }else if(currentActive == 0){
      $('.steps .back-btn').attr('disabled', true);
    }
    
    if(id < 5){
      $('.arrangement-option').show();
      $('.color-option-block').hide();
    }else{
      generateView();
    }
    //console.log(selection);
  });
     
  $(document).on('click', '.return-btn', function(){
    var parent = $(this).parents('div.arrangement-option');
    $(parent).find('ul').addClass('hide');
    var title = $(this).data('title');
    $(parent).find('.option').removeClass('hide');
  });
  
  $(document).on('click', '.child-option', function(){
    var pActive = $(this).parents('.child-options').find('.active').data('title');
    
    var parent = $(this).parents('.child-options');
    
    $(parent).find('.child-option').removeClass('active');
    $(this).addClass('active');
    
    var index = $(this).parents('ul').data('selection');
    var suboption = {
      title : $(this).data('title'),
      sku : $(this).data('sku'),
      max : $(this).parents('ul').data('max'),
      price : $(this).data('price'),
      color : $(this).data('color'),
      image : $(this).data('image'),
      type : $(this).parents('ul').data('option')
    };
    var folder = selection[4].color_design;
    var type = '';
    var isDN = false;
    
    if($(this).data('title').indexOf("Letter") != -1 || $(this).data('title').indexOf("Number") != -1){
      var d = selection[index-1].suboption[0];
      //console.log(d);
      
      selection[index-1].suboption[0].selected = true;
      
      var m = selection[index-1].suboption[0].max;
      
      var i = $(this).parents('.child-options').data('subselection');
      
      var st = selection[index-1].suboption[0].color_design;
      
      if(i == 0){
        selection[index-1].suboption[0].selection1 = $(this).data('title');
        selection[index-1].suboption[0].design1 = st+"-"+$(this).text();
        
        /*if(selection[index-1].title == 'Letter'){
        }else{
          selection[index-1].suboption[0].color_design = st+"-"+$(this).text();
        }*/
      }
      
      if(i == 1){
        if(pActive != $(this).data('title')){
          selection[index-1].suboption[0].selection2 = $(this).data('title');
          selection[index-1].suboption[0].design2 = st+"-"+$(this).text();
        }else{
          $(parent).find('.child-option').removeClass('active');
          delete selection[index-1].suboption[0].selection2;
          delete selection[index-1].suboption[0].design2;
        }
        
        /*if(selection[index-1].title == 'Letter'){          
        }else{
          selection[index-1].suboption[0].color_design = st+"-"+$(this).text();
        }*/
      }
      console.log(selection);
      type = selection[index-1].suboption[0].title;
      
      folder = selection[index-1].suboption[0].design1;
      
      if($(this).data('max') > 1){
        var d1 = selection[index-1].suboption[0].design1;
        var d2 = selection[index-1].suboption[0].design2;
        console.log(d1);
        console.log(d2);
        if(d1 != undefined){
          var d1A = d1.split('|');
          folder = d1A[0]+'|'+d1A[1];
        }
        console.log(d2);
        if(d2 != undefined){
          var d2A = d2.split('|');
          var d1A = d1.split('|');
          folder = d1A[0]+'|'+d1A[1]+'|'+d2A[1];
        }
      }
      
      //console.log(selection);
      //console.log(folder);
      isDN = true;
    }else{
      var op = $(this).data('option');
      $(selection[index-1].suboption).each(function(key, value){
        var d = value;
        d.selected = false;
        //console.log(d);
        selection[index-1].suboption[key] = d;
      });
      selection[index-1].suboption[op].selected = true;
      folder = selection[index-1].suboption[op].color_design;
    }
    
    var im = suboption.image;
    if(im.indexOf('undefined') != -1){
    }else{
      console.log(suboption.image);
      var im = suboption.image;
      var ima = im.replace('.png');
      //var imstr = im[0]+'_500.png?200'
      $('.preview-image').html('<img src="'+ima+'" >');
    }
    
    var finalSubSelectionArr = [];
    
    $(selection).each(function(indexs, values){
      if(indexs < 5){
        if(indexs == 4 && values.suboption != undefined){
          $(values.suboption).each(function(a,b){
            //console.log(b);
            if(b.selected == true){
              if(values.title == 'Letter' || values.title == 'Number'){
                var select = '';
                if(b.selection1 != undefined){select += b.selection1;}
                if(b.selection2 != undefined){select += ' + '+b.selection2;}
                finalSubSelectionArr.push(select);
              }else{
                finalSubSelectionArr.push(b.title);
              }
            }
          });
        }
      }
    });
    
    if(finalSubSelectionArr.length > 0){
      var finalSubSelection = finalSubSelectionArr.join(" + ");
      //console.log(finalSubSelection);
      $('div[data-type="box-arrangement-options"] .options').find('li').eq(4).find('.btn h3').text(finalSubSelection);
      $('div[data-type="box-arrangement-options-second"] .options-two').find('li').eq(4).find('.btn h3').text(finalSubSelection);
    }
        
    showPrice(selection);
    generateColorOptions(folder, isDN, type);
    generateMobileDetail(selection);
  });
  
  $(document).on('click', '.sub-option', function(){
    $(document).find('.sub-option').removeClass('active');
    $(this).addClass('active');
    var colorDir = $(this).data('color');
    
    var ndata = {
      title : $(this).data('title'),
      sku : $(this).data('sku'), 
      price : $(this).data('price'),
      color : $(this).data('color'),
      image : $(this).data('image'),
      type : $(this).parents('ul').data('option')
    };
    var index = $(this).parents('ul').data('selection');
    selection[index] = ndata;
    showPicture();
    
    $('div[data-type="box-arrangement-options"] .options').html('');
    $('div[data-type="box-arrangement-options-second"] .options-two').html('');
    
    $(steps).each(function(key, value){
      var d = JSON.parse(value);
      var block = '';
      var block_two = '';
      var s;
      var i = 0;
      var active = '';

      if(key <= index){
        $(d.data).each(function(k,v){
          if(key != 0){
            selection[key] = selection[key];
            $(v.data).each(function(ka, va){
              if(key == index && ndata.sku == va.sku){
                selection[key] = va;
              }
            });
          }else{
            //selection[key] = v;
            //console.log(ndata.title+" == "+v.title);
            //console.log(key+" == "+index);
            if(key == index && ndata.title == v.title){
              //console.log(v);
              selection[key] = v;
            }
          }
        });
        //console.log(selection);
        var title = selection[key].title,
            sku = selection[key].sku,
            price = selection[key].price,
            type = d.type,
            image = selection[key].image;

        if(selection[key].dimensions != undefined){ var dimensions = selection[key].dimensions; }
        if(selection[key].roses != undefined){ var  roses = selection[key].roses+' Roses'; }
        
        //console.log(selection);
        
        if(key == index){
          active = 'active';
        }
        
        block += '<li class="list-option">'+
          '<button class="btn main-option '+active+'" data-index="'+key+'" data-title="'+title+'" data-type="'+d.type+'" data-dimension="'+dimensions+'" data-roses="'+roses+'" data-price="'+price+'" data-sku="'+sku+'">'+
          '<span class="type">'+d.type+'</span>'+
          '<h3>'+title+'</h3>';
        if(dimensions != undefined){
          block += '<span class="dimension-size">'+ dimensions+" - "+roses +'</span>';
        }
        block +=  '</li>';
        $('div[data-type="box-arrangement-options"] .options').append(block);
        
        
        block_two += '<li class="list-option-two">'+
          '<button class="btn main-option '+active+'" data-index="'+key+'" data-title="'+title+'" data-type="'+d.type+'" data-dimension="'+dimensions+'" data-roses="'+roses+'" data-price="'+price+'" data-sku="'+sku+'">'+
          '<span class="type">'+d.type+'</span>'+
          '<h3>'+title+'</h3>';
        if(dimensions != undefined){
          block_two += '<span class="dimension-size">'+ dimensions+" - "+roses +'</span>';
        }
        block_two +=  '</li>';
        $('div[data-type="box-arrangement-options-second"] .options-two').append(block_two);
      }else{
        
        var parentSKU = selection[key-1];
        var sku = parentSKU.sku;
        $(d.data).each(function(k,v){
          if(key != 0){
            // console.log(v.sku+" == "+sku);
            var sk = v.sku;
            var a = [];
            // console.log(sk.indexOf('|') != -1 && sk.indexOf(sku) != -1);
            if(sk.indexOf('|') != -1 && sk.indexOf(sku) != -1){
              $(v.data).each(function(ka, va){
                //console.log(va);
                if(ka == 0){
                  selection[key] = va;
                }
              });
            }else{
              if(v.sku == sku){
                $(v.data).each(function(ka, va){
                  if(ka == 0){
                    selection[key] = va;
                  }
                });
              }
            }
          }
        });
        
        var title = selection[key].title,
            sku = selection[key].sku,
            price = selection[key].price,
            type = d.type,
            image = selection[key].image;

        if(selection[key].dimensions != undefined){ var dimensions = selection[key].dimensions; }
        if(selection[key].roses != undefined){ var  roses = selection[key].roses+' Roses'; }

        //console.log(selection);
        
        var active = '';
        if(key == 0){
          var active = 'active';
        }

        block += '<li class="list-option hide">'+
          '<button class="btn main-option '+active+'" data-index="'+key+'" data-title="'+title+'" data-type="'+d.type+'" data-dimension="'+dimensions+'" data-roses="'+roses+'" data-price="'+price+'" data-sku="'+sku+'">'+
          '<span class="type">'+d.type+'</span>'+
          '<h3>'+title+'</h3>';
        if(dimensions != undefined){
          block += '<span class="dimension-size">'+ dimensions+" - "+roses +'</span>';
        }
        block +=  '</li>';
        
        $('div[data-type="box-arrangement-options"] .options').append(block);
        
        block_two += '<li class="list-option-two hide">'+
          '<button class="btn main-option '+active+'" data-index="'+key+'" data-title="'+title+'" data-type="'+d.type+'" data-dimension="'+dimensions+'" data-roses="'+roses+'" data-price="'+price+'" data-sku="'+sku+'">'+
          '<span class="type">'+d.type+'</span>'+
          '<h3>'+title+'</h3>';
        if(dimensions != undefined){
          block_two += '<span class="dimension-size">'+ dimensions+" - "+roses +'</span>';
        }
        block_two +=  '</li>';
        
        $('div[data-type="box-arrangement-options-second"] .options-two').append(block_two);
      }
    });
    
    
    
    
    
    
    
    
    
    var folder = selection[4].color_design;
   
    showPrice(selection);
    /*if($(this).parents('.option').data('option') == 'Box Size'){
      showPrice(selection);
    }else{
      hidePrice();
    }*/
    if($(this).parents('.option').data('option') == 'Arrangement'){
      if(selection[4].suboption == undefined){
        //console.log('sdfs');
        generateColorOptions(folder);
      }
    }
    generateMobileDetail(selection);
    /*
    if(selection[4].suboption == undefined){
      generateColorOptions(folder);
    }*/
    
    /*if($(this).hasClass('hasChild')){
    }else{
      $('.steps .next-btn').trigger('click');
    }*/
  });

  $(document).on('click', '.sub-option.hasChild', function(){
    var parent = $(this).parents('div.arrangement-option');
    $(parent).find('ul').addClass('hide');
    var title = $(this).data('title');
    $(parent).find('ul[data-parent="'+title+'"]').removeClass('hide');        
    
    $(document).find('.sub-option').removeClass('active');
    $(this).addClass('active');
    
    //console.log($(parent).find('ul[data-parent="'+title+'"]').find('li').eq(1).text());
    //console.log($(document).find('ul[data-parent="'+title+'"]').find('li').eq(1).find('button'));
    
    /*if(title == 'Letter' || title == 'Digit'){
      if(selection[4].suboption[0].design1 == undefined || selection[4].suboption[0].design2 == undefined){
        $(document).find('ul[data-parent="'+title+'"]').each(function(kq, kv){
          $(kv).find('li').eq(1).find('button').trigger('click');
        });
      }
    }*/
    $(document).find('ul[data-parent="'+title+'"]').find('li').eq(1).find('button').trigger('click');
    
    generateMobileDetail(selection);
  });
  
  $('.steps .btn').on('click', function(){
    if($(this).hasClass('back-btn') || $(this).hasClass('next-btn')){
      var back = currentActive-1, next = currentActive+1;
      //console.log(back);

      $('.preview-image').removeClass('color-combination');

      //hideLidMessage();
      //$('[data-type="box-arrangement-options"] .options').find('li').eq(currentActive).find('.btn').removeClass('active');
      if($(this).hasClass('back-btn')){
        $('[data-type="box-arrangement-options"] .options').find('li').removeClass('hide').eq(back).find('.btn').trigger('click');
        $('[data-type="box-arrangement-options-second"] .options-two').find('li').removeClass('hide').eq(back).find('.btn').trigger('click');
        /*if(currentActive == 6){
        generateView();
      }else{
        $('.arrangement-option').show();
        $('.color-option-block').hide();
        generateSteps(steps[back], back, selection);
      }*/      
        $('.steps').find('.add-to-cart').addClass('hide');
        $('.steps').find('.next-btn').removeClass('hide');
        generateMobileDetail(selection);
      }else{
        //console.log(currentActive);
        if(currentActive < 5){
          $('[data-type="box-arrangement-options"] .options').find('li').removeClass('hide').eq(next).find('.btn').trigger('click');
          $('[data-type="box-arrangement-options-second"] .options-two').find('li').removeClass('hide').eq(next).find('.btn').trigger('click');
          if(currentActive == 5){
            $('.steps').find('.add-to-cart').removeClass('hide');
            $('.steps').find('.next-btn').addClass('hide');
          }
        }else if(currentActive == 5){
          //showLidMessage();
        }
        var wWidth = $(window).width();
        if(wWidth <= 620){
          //if(currentActive >= 3){
            //console.log('dds');
            generateMobileDetail(selection);
            $('.mobile-area-wrapper').show();
            $('.mobile-area-wrapper').addClass('hasD');
          /*}else{
            $('.mobile-area-wrapper').hide();
            $('.mobile-area-wrapper').removeClass('hasD');
          }*/
        }
        /*if(currentActive == 4){
          generateView();
        }else{
          $('.arrangement-option').show();
          $('.color-option-block').hide();
          generateSteps(steps[next], next, selection);
        }*/
      }
    }
  });
  $('.mobile-area-wrapper').hide();

  $(document).on('click', '.color-option', function(){
    var $parents = $(this).parents('.color-options');
    $parents.find('.color-option').removeClass('active');
    $(this).addClass('active');
    var img = $(this).data('image');
    var index = $parents.data('index');
    
    showPicture(true, index);
    
    var t = [];
    var tit = [];
    $('.color-option-block .color-options').each(function(k,v){
      var title = $(v).find('.active').data('title');
      var image = $(v).find('.active').data('image');
      var d = {
        title : title,
        image : image
      };
      t.push(d);
      tit.push(title);
    });
    console.log(t);
    selection[5] = t;
    
    $('.options li').eq(5).find('h3').text(tit.join(' + '));
    console.log('color');
    console.log(selection);
    generateMobileDetail(selection);
  });

  /*var lidHtml = '';
  $(lidMessageArr).each(function(k,v){
    var av = '';
    if(k == 0){av = 'active';}
    lidHtml += '<li><button class="btn '+av+'" data-index="'+k+'" data-title="'+v+'">'+v+'</button></li>';
  });
  $('.lid-messages').html('<ul class="option-lid">'+lidHtml+'</ul>');
  
  $(document).on('click', '.option-lid .btn', function(){
    $(document).find('.option-lid').find('.btn').removeClass('active');
    $(this).addClass('active');
    if(selection[6] != undefined){
      selection[6].message = $(this).data('title');
    }else{
      selection[6] = {message: $(this).data('title')};
    }
    
    var sele = $(this).data('title');
    $('div[data-type="box-arrangement-options"] .options').find('li').eq(6).html('<button class="btn main-option " data-index="7" data-title="'+sele+'" data-type="Lid Message" >'+
       '<span class="type">Lid Message</span><h3>'+sele+'</h3></button></li>');
    console.log(selection);
  });*/
  
  $('.add-to-cart').on('click', function(){
    console.log(productListArr);
    console.log(selection);
    var handle = '';
    var query = [];
    $(productListArr).each(function(ke,value){
      var selectSKU = $.trim(selection[4].sku);
      if(selection[4].suboption != undefined){
        $(selection[4].suboption).each(function(k,v){
          if(v.selected == true){
            selectSKU = $.trim(v.sku);
          }
        });
      }
                                         
      if(selectSKU == value.sku){
        handle = value.handle;
        selection.push({handle:handle})
        var customSelection = JSON.stringify(selection);
        customSelection = customSelection.replace(/&quot;/g, "*");

        console.log("--------- customSelection", JSON.parse(customSelection));
        setCookie('custom_selection',customSelection,10);
        /*//break;
        query.push('box_color='+selection[2].title);
        //query.push('box_dimensions='+selection[3].dimensions);
        //query.push('box_roses='+selection[3].roses);
        //query.push({box_title:selection[3].dimensions});
        if(selection[4].suboption != undefined){
          $(selection[4].suboption).each(function(k,v){
            if(v.selected == true){
              query.push('selection='+v.title);
              if(v.title == 'Number' || v.title=='Letter'){
                var sub = '';
                sub += v.selection1;
                if(v.selection2 != undefined){
                  sub += '|'+v.selection2;
                }
                query.push('sub='+sub);
              }
            }
          });
        }else{
          query.push('selection='+selection[4].title);
        }
        var a = selection[5];
        var c = a.join('|');
        c = c.replace('&', '-');
        query.push('color='+c);*/
      }      
    });
    //console.log(handle);
    //console.log(query);
    
    //var queryString = query.join('&');
    var url = '/products/'+handle;
    console.log(url);
    setTimeout(function(){
      location.href=url;
    }, 5000);
  });
  
  $('.scroll-btn').click(function(){
    var top = $('div[data-type="box-arrangement-options"]').offset().top - 50;
    console.log(top);
    $('html,body').animate({
      scrollTop: top
    }, 'slow');
  });
  
  /*var p = $( 'div[data-type="box-arrangement-options"]' );
  var offset = p.offset();
  offset = offset.top;
  $(window).scroll(function () {
    console.log($(window).scrollTop()+" = "+offset)
    if ($(window).scrollTop()   >  offset ) {
      $('.mobile-area-wrapper').fadeIn();
    }else{
      $('.mobile-area-wrapper').fadeOut();
    }
  });*/
  
  /*window.onscroll = function (e) {  
    if ($('div[data-type="box-arrangement-options"]').css('visibility') === 'hidden') {
      $('.mobile-area-wrapper').fadeIn();
    } else {
      $('.mobile-area-wrapper').fadeOut();
      
    }
  } */
  
  $(window).scroll(function (event) {
    var width = $(window).width();
    
    var top = $('div[data-type="box-arrangement-options"]').offset().top - 50;
    var height = $('div[data-type="box-arrangement-options"]').height() / 2 + ($('div[data-type="box-arrangement-options"]').height() / 4);
    var bottom = top + height;
    var scroll = $(window).scrollTop();
   
    if(width <= 620){
      if($('.mobile-area-wrapper').hasClass('hasD')){
        if(scroll > top && scroll < bottom){
          $('.mobile-area-wrapper').fadeOut();
        }else{
          $('.mobile-area-wrapper').fadeIn();
        }
      }
    }
    // Do something
    
    // console.log(scroll);
    // var sc = 60;
    // if(width < 992){
    //   var sc = 140;
    // }
    // if (scroll >= 140) {
    //   $(".navigation").addClass("sticky");
    // }else{
    //   $(".navigation").removeClass("sticky");
    // }
  });
    
});

function generateMobileDetail(selection){
  var arrangement = [], style = [], roses = [], price = '';
  var arrangementS, styleS, rosesS, price = '';
  $(selection).each(function(k, v){
    if(k == 1 || k == 2){
      arrangement.push(v.title);
    }
    if(k == 4){
      style.push(v.title);
    }
    if(k == 5){
      $(v).each(function(ka,va){
        roses.push(va.title);
      });
    }
  });
  if(selection[5] != undefined){
    $('.mobile-roses span').show();
  }else{
    $('.mobile-roses span').hide();
  }
  arrangementS = arrangement.join(' / ');
  styleS = style.join(' / ');
  rosesS = roses.join(' / ');
  price = totalPrice(selection);
  $('.mobile-arrangment .detail').text(arrangementS);
  $('.mobile-style .detail').text(styleS);
  $('.mobile-roses .detail').text(rosesS);
  $('.mobile-price .detail').text(price);
}

function showLidMessage(){
  $('.lid-messages').removeClass('hide');
  $('.arrangement-option').addClass('hide');
  $('.color-option-block').addClass('hide');
  
  var sele = $('.lid-messages').find('.active').data('title');
  if($('div[data-type="box-arrangement-options"] .options').find('li').eq(6).length >  0){
    $('div[data-type="box-arrangement-options"] .options').find('li').eq(6).html('<button class="btn main-option" data-index="6" data-title="'+sele+'" data-type="Lid Message">'+'<span class="type">Lid Message</span><h3>'+sele+'</h3></button></li>');
  }else{
    $('div[data-type="box-arrangement-options"] .options').append('<li class="list-option">'+
       '<button class="btn main-option" data-index="6" data-title="'+sele+'" data-type="Lid Message" >'+
       '<span class="type">Lid Message</span><h3>'+sele+'</h3></button></li>');
  }
  
  $(document).find('.options').find('.main-option').removeClass('active');
  $('div[data-type="box-arrangement-options"] .options').find('li').eq(6).find('.btn').addClass('active');
}

function hideLidMessage(){
  $('.lid-messages').addClass('hide');
  $('.arrangement-option').removeClass('hide');
  $('.color-option-block').removeClass('hide');
}

function hidePrice(){
  $('.final-prices').addClass('hide');
}

function totalPrice(selection){
  var totalPrice = 0;
  $(selection).each(function(indexs, values){
    if(indexs < 5){
      var p = 0;
      if(indexs == 4 && values.suboption != undefined){
        $(values.suboption).each(function(a,b){
          if(b.selected == true){
            p = b.price;
          }
        });
      }else{
        p = values.price;
      }
      totalPrice += parseFloat(p);
    }
  });
  return totalPrice;
}

function showPrice(selection){
  var totalPrice = 0;
  $(selection).each(function(indexs, values){
    if(indexs < 5){
      var p = 0;
      if(indexs == 4 && values.suboption != undefined){
        $(values.suboption).each(function(a,b){
          if(b.selected == true){
            p = b.price;
          }
        });
      }else{
        p = values.price;
      }
      totalPrice += parseFloat(p);
    }
  });
  if(totalPrice != 0){
    $('.final-prices').removeClass('hide').html('<span>Price</span>'+'<h3>$'+totalPrice+'</h3>');
  }
}

function generateView(){
  $('.arrangement-option').hide();
  $('.color-option-block').show();

  $('.preview-image').html('');

  $('.preview-image').addClass('color-combination');
  var h = '';
  
  var t = [];
  var tit = [];
  $('.color-option-block .color-options').each(function(k,v){
    //console.log($(v).find('.active').data('image'));
    var img = $(v).find('.active').data('image');
    var title = $(v).find('.active').data('title');
    var d = {
      title : title,
      image : img
    }
    t.push(d);
    tit.push(title);
    $('.preview-image').append('<img src="'+img+'" data-index="'+k+'" >');    
  });
  
  selection[5] = t;
  
  $('.steps .btn.back-btn').attr('disabled', false);  
}

function generateSteps(step, index, selection){
  var optionsArr = JSON.parse(step);
  var options = '';
  
  //console.log(selection);
  //console.log(optionsArr);
  var currentSKU = selection[index];
  if(index != 0){
    var parentSKU = selection[index-1];
  }
  
  if(index == 0){
    $(optionsArr.data).each(function(key, value){
      var img = value.image;
      if(value.sku == currentSKU.sku){
        options += '<li><button class="btn active sub-option" data-title="'+value.title+'" data-sku="'+value.sku+'" data-price="'+value.price+'" data-image="'+fileurl+value.image+'" >'+value.title+'</button></li>';
      }else{
        options += '<li><button class="btn sub-option" data-title="'+value.title+'" data-sku="'+value.sku+'" data-price="'+value.price+'" data-image="'+fileurl+value.image+'" >'+value.title+'</button></li>';
      }
    });
    $('div[data-type="box-options-styles"] .arrangement-option').html('<ul class="option" data-selection="'+index+'" data-option="'+optionsArr.type+'">'+options+'</ul>');
  }else{
    $(optionsArr.data).each(function(k, val){
      var p = parentSKU.sku;
      var v = val.sku;
      
      if(v.indexOf('|') != -1 && v.indexOf(p) != -1){
        var suboptions = '';
        //console.log(val.data);
        $(val.data).each(function(key, value){
          var suboption = generateSubOptions(value, index, selection);
          var isChild = '';
          
          if(value.suboption != undefined){
            isChild = 'hasChild';
            //suboptions = '<div class="sub-option-block"></div>';
          }
          
          suboptions += suboption;
          //console.log(isChild);
          
          var img = value.image;
          if(value.sku == currentSKU.sku){
            options += '<li><button data-color="'+value.color_design+'" class="btn active sub-option '+isChild+'" data-title="'+value.title+'" data-sku="'+value.sku+'" data-price="'+value.price+'" data-image="'+fileurl+value.image+'" >'+value.title+'</button></li>';
          }else{
            options += '<li><button data-color="'+value.color_design+'" class="btn sub-option '+isChild+'" data-title="'+value.title+'" data-sku="'+value.sku+'" data-price="'+value.price+'" data-image="'+fileurl+value.image+'" >'+value.title+'</button></li>';
          }
        });
        $('div[data-type="box-options-styles"] .arrangement-option').html('<ul class="option" data-selection="'+index+'" data-option="'+optionsArr.type+'">'+options+'</ul>'+suboptions);
      }else{
        var suboptions = '';
        if(val.sku == parentSKU.sku){
          $(val.data).each(function(key, value){
            var suboption = generateSubOptions(value, index);
            var isChild = '';
            
            if(value.suboption != undefined){
              isChild = 'hasChild';
              //suboptions = '<div class="sub-option-block"></div>';
            }
            
            suboptions += suboption;
            //console.log(isChild);
            
            var img = value.image;
            if(value.sku == currentSKU.sku){
              options += '<li><button data-color="'+value.color_design+'" class="btn active sub-option '+isChild+'" data-title="'+value.title+'" data-sku="'+value.sku+'" data-price="'+value.price+'" data-image="'+fileurl+value.image+'" >'+value.title+'</button></li>';
            }else{
              options += '<li><button data-color="'+value.color_design+'" class="btn sub-option '+isChild+'" data-title="'+value.title+'" data-sku="'+value.sku+'" data-price="'+value.price+'" data-image="'+fileurl+value.image+'" >'+value.title+'</button></li>';
            }
          });
          $('div[data-type="box-options-styles"] .arrangement-option').html('<ul class="option" data-selection="'+index+'" data-option="'+optionsArr.type+'">'+options+'</ul>'+suboptions);
        }
      }
      
      //$('.arrangement-option ul.child-options').find('li[data-subselection="0"]').eq(0).find('button').trigger('click');
      $('.arrangement-option ul.child-options').each(function(k,v){
        $(v).find('li[data-subselection="0"]').eq(0).find('button').trigger('click');
      });
      
    });
    
    
  }
  if(index == 4){
    var folder = selection[4].color_design;
    generateColorOptions(folder);
  }
  /*var folder = selection[4].color_design;
  generateColorOptions(folder);*/
  showPicture();
}

function generateSubOptions(value, index, selection){
  var LettersString = "A,B,C,D,E,F,G,H,I,J,K,L,M,N,O,P,Q,R,S,T,U,V,W,X,Y,Z";
  var DigitsString = "0,1,2,3,4,5,6,7,8,9";
  
  var letter = LettersString.split(',');
  var digit = DigitsString.split(',');
  
  var suboptions = '';  
  var suboption = '';

  if(value.suboption != undefined){
    $(document).find('.sub-option-block').html('');    
    
    var s = index+1;
    
    suboption += '<li class="return"><button class="btn return-btn">Back to All Style</button></li>';    
    
    if(value.title == 'Number'){
      var selected1 = '', selected2='';
      /*if(selection[4] != undefined && selection[4].suboption != undefined){
        if(selection[4].suboption[0].selection1 != undefined){
          selected1 = selection[4].suboption[0].selection1;
        }else{

        }
        if(selection[4].suboption[0].selection2 != undefined){
          selected2 = selection[4].suboption[0].selection2;
        }
      }*/
      
      var sub = value.suboption[0];
      var max = '';
      var title = '';
      
      if(sub.max > 1){max = ' more';}
      
      for(var o=0; o < sub.max; o++){
        suboption = '';
        
        if(o == 0){
          suboption += '<li class="return"><button class="btn return-btn">Back to All Style</button></li>';
          
          suboption += '<li class="sub-option-title"><span>Required First Number</span></li>';
        }else{
          suboption += '<li class="sub-option-title"><span>Optional Second Number</span></li>';
        }
        
        $(digit).each(function(ke, va){
          var ac = '';
          
          var titl = 'Number '+va;
          
          if(ke == 0 && o == 0){
            ac = ' active';
          }
          /*if((ke == 0 && o == 0 && selected1 == '') || (ke == 0 && o == 1 && selected2 == '')){ 
            ac = ' active';
          }else{            
            if(o == 0 && selected1 != '' && titl == selected1){
              ac = ' active';
            }
            if(o == 1 && selected2 != '' && titl == selected2){
              ac = ' active';
            }
          }*/
          
          suboption += '<li><button data-max="'+sub.max+'" class="btn child-option'+ac + max+'" data-image="'+fileurl+value.image+'" data-color="'+sub.color_design+'" data-title="'+titl+'" data-price="'+sub.price+'" data-sku="'+sub.sku+'-'+va+'" >'+va+'</button></li>';
        });
        suboptions += title+'<ul class="child-options small-options hide" data-option="Sub Option" data-subselection="'+o+'" data-selection="'+s+'" data-parent="'+value.title+'">'+suboption+'</ul>';
      }
    }else if(value.title == 'Letter'){
      var selected1 = '', selected2='';
      /*if(selection[4] != undefined && selection[4].suboption != undefined){
        if(selection[4].suboption[0].selection1 != undefined){
          selected1 = selection[4].suboption[0].selection1;
        }else{

        }
        if(selection[4].suboption[0].selection2 != undefined){
          selected2 = selection[4].suboption[0].selection2;
        }
      }*/
      
      var sub = value.suboption[0];
      var max = '';
      var title = '';
      
      if(sub.max > 1){
        max = ' more';
      }
      
      for(var o=0; o < sub.max; o++){
        suboption = '';
        
        if(o == 0){
          suboption += '<li class="return"><button class="btn return-btn">Back to All Style</button></li>';

          suboption += '<li class="sub-option-title"><span>Required First Letter</span></li>';
        }else{
          suboption += '<li class="sub-option-title"><span>Optional Second Letter</span></li>';
        }
        
        $(letter).each(function(ke, va){
          var ac = '';
          
          var titl = 'Letter '+va;

          if(ke == 0 && o == 0){
            ac = ' active';
          }
          /*if((ke == 0 && o == 0 && selected1 == '') || (ke == 0 && o == 1 && selected2 == '')){ 
            ac = ' active';
          }else{            
            if(o == 0 && selected1 != '' && titl == selected1){
              ac = ' active';
            }
            if(o == 1 && selected2 != '' && titl == selected2){
              ac = ' active';
            }
          }*/
          
          suboption += '<li><button data-max="'+sub.max+'" class="btn child-option'+ac + max+'" data-image="'+fileurl+value.image+'" data-color="'+sub.color_design+'" data-title="'+titl+'" data-price="'+sub.price+'" data-sku="'+sub.price+'-'+va+'" >'+va+'</button></li>';
        });
        suboptions += title+'<ul class="child-options small-options hide" data-option="Sub Option" data-subselection="'+o+'" data-selection="'+s+'" data-parent="'+value.title+'">'+suboption+'</ul>';
      }
    }else{
      $(value.suboption).each(function(ke, va){
        var ac = '';
        if(ke == 0){ ac = 'active'; }
        suboption += '<li><button data-option="'+ke+'" data-color="'+va.color_design+'" class="btn child-option '+ac+'" data-title="'+va.title+'" data-sku="'+va.sku+'" data-price="'+va.price+'" data-image="'+fileurl+va.image+'" >'+va.title+'</button></li>';
      });
      suboptions = '<ul class="child-options hide" data-option="Sub Option" data-selection="'+s+'" data-parent="'+value.title+'">'+suboption+'</ul>';
    }
  }
  return suboptions;
}

function generateColorOptions(folder, isDN, type){
  var colors = "Blue|Pink & Green Mix|Orange|Pink|White & Pink|Black|Royal Blue|Gold|Green|Dark Green|Hot Pink|Light Pink|Rainbow|Red|Silver|Light Purple|Purple|White|Yellow|Light Yellow";
  var letterDigitColor = "White-18|Gold-8|Light Pink-12|Red-14|Silver-15|Purple-17|Blue-1";
  var colorsArr = colors.split('|');
  var letterDigitColorArr = letterDigitColor.split('|');  
  var fileurl = 'https://cdn.shopify.com/s/files/1/0111/0537/0171/files/';
  var selectedColor = [];
  
  //console.log(folder);
  
  $('.color-option-block').html('');  
  if(folder != undefined && folder.indexOf('|') != -1){
    var t = folder.split('|');
    var currTime = new Date().getTime();
    
    var size = t.length;
    for(var i=0; i<size; i++){
      var colorHTML = '';
      var loop =[];
      
      if(isDN == true && i !=0){
        loop = letterDigitColorArr;
      }else{
        loop = colorsArr;
      }
      
      $(loop).each(function(key,value){        
        var ti = '';
        var index = 0;
        var folderIndex = 0;
        if(value.indexOf('-') != -1){
          var a = value.split('-');
          ti = a[0];
          index = a[1];
          folderIndex = key + 1;
        }else{
          ti=value;
          index = key + 1;
          folderIndex = index;
        }
        
        if(key == 0){selectedColor.push(ti);}
        
        var ac = '';

        if(key == 0){var ac = ' active';}
        
        if(type == 'Letter' && i !=0){
          colorHTML += '<li><a data-image="'+fileurl+t[i]+folderIndex+'-01_450x.png?'+currTime+'" data-index="'+key+'" class="color-option'+ac+'" data-title="'+ti+'"><img src="'+fileurl+'swatch-'+index+'_65x.png"></a></li>';
        }else{
          colorHTML += '<li><a data-image="'+fileurl+t[i]+'-'+folderIndex+'_450x.png?'+currTime+'" data-index="'+key+'" class="color-option'+ac+'" data-title="'+ti+'"><img src="'+fileurl+'swatch-'+index+'_65x.png"></a></li>';
        }
      });
      var title = '';
      if(i == 0){title = 'Background color';}
      else if(i == 1){
        title = 'Design Color 1';
        $('.preview-image').removeClass('hasMore');
      }
      else if(i == 2){
        title = 'Design Color 2';
        if(isDN == true){
          $('.preview-image').addClass('hasMore');
        }else{
          $('.preview-image').removeClass('hasMore');
        }
      }
      else if(i == 3){title = 'Design Color 3';}
      
      $('.color-option-block').append('<h4 class="head-title">'+title+'</h4><ul class="color-options" data-title="'+title+'" data-index="'+i+'" >'+colorHTML+'</ul>');
    }
  }else{
    var colorHTML = '';
    if(folder != '38-D' && folder != '39-D'){
      $(colorsArr).each(function(key,value){
        if(key == 0){selectedColor.push(value);}
        var index = key + 1;
        var ac = '';
        if(key == 0){var ac = ' active';}
        colorHTML += '<li><a data-image="'+fileurl+folder+'-'+index+'_450x.png?'+currTime+'" data-index="'+key+'" class="color-option'+ac+'" data-title="'+value+'"><img src="'+fileurl+'swatch-'+index+'_65x.png"></a></li>';
      });
    }else{
      for(var p = 1; p<=3; p++){
        var ac = '';
        if(p == 1){
          var ac = ' active';
          selectedColor.push('Gradiant '+p);
        }
        colorHTML += '<li><a data-image="'+fileurl+folder+'-'+p+'_450x.png?'+currTime+'" data-index="'+p+'" class="single-img color-option'+ac+'" data-title="Gradiant '+p+'"><img src="'+fileurl+folder+'-'+p+'_65x.png"></a></li>';
      }
    }
    $('.color-option-block').append('<ul class="color-options" data-index="0">'+colorHTML+'</ul>');
  }

  var title = selectedColor.join(" + ");  
  var block = '';
  var block_two = '';
  
  //console.log(selectedColor);
  block = '<li class="list-option">'+
    '<button class="btn main-option" data-index="5" data-title="'+title+'" data-type="Rose Colors" data-sku="B">'+
    '<span class="type">Rose Colors</span>'+
    '<h3>'+title+'</h3></button></li>';
  
  if($('div[data-type="box-arrangement-options"] .options').find('li').eq(5).length >  0){
    $('div[data-type="box-arrangement-options"] .options').find('li').eq(5).html('<button class="btn main-option" data-index="5" data-title="'+title+'" data-type="Rose Colors" data-sku="B">'+
    '<span class="type">Rose Colors</span>'+
    '<h3>'+title+'</h3></button>');
  }else{
    $('div[data-type="box-arrangement-options"] .options').append(block);
  }
  
  
  block_two = '<li class="list-option-two">'+
    '<button class="btn main-option" data-index="5" data-title="'+title+'" data-type="Rose Colors" data-sku="B">'+
    '<span class="type">Rose Colors</span>'+
    '<h3>'+title+'</h3></button></li>';
  
  if($('div[data-type="box-arrangement-options-second"] .options-two').find('li').eq(5).length >  0){
    $('div[data-type="box-arrangement-options-second"] .options-two').find('li').eq(5).html('<button class="btn main-option" data-index="5" data-title="'+title+'" data-type="Rose Colors" data-sku="B">'+
    '<span class="type">Rose Colors</span>'+
    '<h3>'+title+'</h3></button>');
  }else{
    $('div[data-type="box-arrangement-options-second"] .options-two').append(block_two);
  }
  
  
  
  $('.color-option-block .color-options').each(function(k,v){
    if(k == 0){
      var title = $(v).find('.active').trigger('click');
    }
  });
}

function showPicture(isColor = false, index = 0){
  var currTime = new Date().getTime();
  if(isColor == true){
    //console.log(index);
    var img = $(document).find('.color-option-block').find('ul[data-index="'+index+'"]').find('.active').data('image');
    //console.log(img);
    $('.preview-image').find('img[data-index="'+index+'"]').attr('src', img);
    
  }else{
    var img = $(document).find('.arrangement-option').find('.active').data('image');
    //console.log(img.indexOf('undefined'));
    if(img.indexOf('undefined') == -1){
      var arr = [], newIMG = '';
      if(img.indexOf('.jpg') != -1){
        arr = img.split('.jpg');
        newIMG = arr[0]+'_500x.jpg?'+currTime;
      }
      if(img.indexOf('.png') != -1){
        arr = img.split('.png');
        newIMG = arr[0]+'.png?'+currTime;
      }
      $('.preview-image').html('<img src="'+newIMG+'" >');
    }
  }
}

generateSteps(steps[0], 0, selection);
 